var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.062 1.57V1.5C15.0599 1.10282 14.9012 0.722512 14.6203 0.441662C14.3395 0.160812 13.9592 0.00210151 13.562 0L7.99399 0C7.59681 0.00210151 7.21652 0.160812 6.93567 0.441662C6.65482 0.722512 6.49609 1.10282 6.49399 1.5V1.57H0V30.338H21.522V1.57H15.062ZM19.381 28.231H2.14099V3.676H6.5V4.818C6.50494 5.25195 6.67952 5.66674 6.98639 5.97361C7.29326 6.28048 7.70805 6.45506 8.142 6.46H8.35599C8.75201 6.45959 9.13414 6.31404 9.43008 6.05089C9.72603 5.78774 9.91529 5.42525 9.96201 5.032V4.961C9.9956 4.74005 10.1081 4.53877 10.2787 4.39443C10.4494 4.2501 10.6666 4.17249 10.89 4.176C11.117 4.18038 11.335 4.26539 11.505 4.41581C11.675 4.56623 11.786 4.77225 11.818 4.997V5.068C11.8637 5.46129 12.052 5.8242 12.3472 6.08807C12.6424 6.35194 13.0241 6.49849 13.42 6.5C13.854 6.49506 14.2688 6.32048 14.5756 6.01361C14.8825 5.70674 15.0571 5.29195 15.062 4.858V3.712H19.416V28.232L19.381 28.231Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.596 9.38702H4.925V11.528H16.596V9.38702Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.596 13.063H4.925V15.204H16.596V13.063Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.596 16.739H4.925V18.88H16.596V16.739Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.596 20.38H4.925V22.521H16.596V20.38Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.39d999fb9c61625aaee02f673c054fc0.svg";
export { ForwardRef as ReactComponent };